import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MDBDropdownItem, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu } from "mdbreact";

import { connect } from 'react-redux';
import { GetProveedorDetalleEnAPI, SetDocumentoProveedorEnAPI, GetDocumentoProveedorEnAPI, SetMarcaProveedorEnAPI, ObtenerEndPoint } from "../../action/actionCreatorsRequests";
import { MSGERROR, MSGOK, traducirPagina, obtenerToken, obtenerUsuario } from "../../librerias/funciones"
import {
    PlusOutlined,
    CloseOutlined,
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    DownOutlined,
    CloudDownloadOutlined,
    DollarCircleFilled
} from '@ant-design/icons';
import { Select, Card, Drawer, Modal, Button, Form, Input, Checkbox, Row, Col, Tabs } from 'antd';
import FichaTarifasProveedor from "./FichaTarifasProveedor"
import VisorGenerico from '../VisorGenerico';

import store from '../../store'
import FichaProveedorMarca from './FichaProveedorMarca';
const { Option } = Select;
const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;

const FichaDetalleProveedor = ({ props, configApp }) => {

    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)



    const [activeTabMenu, setActiveTabMenu] = React.useState(1);

    const [hayCliente, setHayCliente] = React.useState(false);
    const [abrirVisor, setAbrirVisor] = React.useState(false);
    const [abrirTarifas, setAbrirTarifas] = React.useState(false);

    const [ficheroSeleccionado, setFicheroSeleccionado] = React.useState({});
    const [registroMarcaSeleccionada, setRegistroMarcaSeleccionada] = React.useState({});
    const [documentoSeleccionado, setDocumentoSeleccionado] = React.useState({});



    const [proveedor, setproveedor] = React.useState(
        {
            CONTACTOS: [],
            DETALLE: [],
            DOCUMENTOS: [],
            MARCAS: []
        }
    )

    const [filtros, setFiltros] = React.useState(
        {
            ANYO_SELECCIONADO: "",
            PAIS_SELECCIONADO: "",
            CATEGORIA_SELECCIONADO: "",
            ANYO_ACTIVO: false
        }
    )

    const {
        ACTIVO,
        CIF,
        CODIGO_POSTAL_FISCAL,
        CODIGO_POSTAL_LOCAL,
        DIRECCION_FISCAL,
        DIRECCION_LOCAL,
        EMAIL,
        HOMOLOGADO_IDAP,
        HOMOLOGADO_NEXUS,
        HOMOLOGADO_SERCA,
        INFORMACION_ADICIONAL_FISCAL,
        INFORMACION_ADICIONAL_LOCAL,
        NOMBRE_COMERCIAL,
        NOMBRE_FISCAL,
        PAIS_FISCAL,
        PAIS_LOCAL,
        POBLACION_FISCAL,
        POBLACION_LOCAL,
        PROVINCIA_FISCAL,
        PROVINCIA_LOCAL,
        TELEFONO1,
        TELEFONO2,
        TELEFONO3,
        TIPO_DE_PATROCINADOR
    } = proveedor.DETALLE !== undefined && proveedor.DETALLE !== null && proveedor.DETALLE.length > 0 ? proveedor.DETALLE[0] : [];


    const filtroUnicoPais = (registros) => {
        let unique = []
        if (registros !== undefined && registros !== null) {
            unique = [...new Set(registros.map(item => item.PAIS))];
        }
        return unique;
    }

    const filtroUnicoCategoria = (registros) => {
        let unique = []
        if (registros !== undefined && registros !== null) {
            unique = [...new Set(registros.map(item => item.CATEGORIA_DOCUMENTO))];
        }
        return unique;
    }


    const filtroUnicoAnyo = (registros) => {
        let unique = []
        if (registros !== undefined && registros !== null) {
            unique = [...new Set(registros.map(item => item.ANYO))];
        }

        return unique;
    }

    const obtenerDocumento = async (ID, ID_PROVEEDOR, NOMBRE, EXTENSION) => {
        setFicheroSeleccionado({});

        setFicheroSeleccionado({
            TITULO: NOMBRE === undefined || NOMBRE === null ? "VISTA PREVIA" : NOMBRE,
            TIPO_DOCUMENTO: obtenerImagenPorExtension(EXTENSION) === "imagen.png" ? "IMG" : "DOC",
            URL: `${ObtenerEndPoint()}api/NextGroup/VisualizarDocumentoProveedor/${ID}/${ID_PROVEEDOR}/${window.btoa(obtenerToken())}`,
            FICHERO: {}
        })


        setAbrirVisor(true);



    }

    const GetProveedorDetalle = (ID) => {
        GetProveedorDetalleEnAPI(ID).then((registro) => {
            if (registro !== undefined && registro !== null) {
                const { CONTACTOS, DETALLE, DOCUMENTOS, MARCAS } = registro;
                proveedor.CONTACTOS = CONTACTOS
                proveedor.DETALLE = DETALLE
                proveedor.DOCUMENTOS = DOCUMENTOS === null || DOCUMENTOS.length === 0 ? null : DOCUMENTOS
                proveedor.MARCAS = MARCAS

                setproveedor({ ...proveedor })


/*
                let filtroNayo = filtroUnicoAnyo(DOCUMENTOS);
                filtros.ANYO_SELECCIONADO = filtroNayo[0];
                setFiltros({ ...filtros })
                */
            } else {
                setproveedor(
                    {
                        CONTACTOS: null,
                        DETALLE: null,
                        DOCUMENTOS: null
                    }
                )
            }
        })
    }

    const gestionnarFiltrosLocales = (REGISTROS) => {
        const { ANYO_SELECCIONADO, PAIS_SELECCIONADO, CATEGORIA_SELECCIONADO, ANYO_ACTIVO } = filtros;
        let resultado = REGISTROS;

     

        if (PAIS_SELECCIONADO !== "") {
            resultado = REGISTROS.filter((registro) => registro.PAIS === PAIS_SELECCIONADO)
        }

        if (CATEGORIA_SELECCIONADO !== "") {
            resultado = REGISTROS.filter((registro) => registro.CATEGORIA_DOCUMENTO === CATEGORIA_SELECCIONADO)
        }

        if ( ANYO_SELECCIONADO !== "") {

            resultado = REGISTROS.filter((registro) => registro.ANYO === ANYO_SELECCIONADO)

            if (CATEGORIA_SELECCIONADO !== "") {
                resultado = REGISTROS.filter((registro) => registro.ANYO === ANYO_SELECCIONADO && registro.CATEGORIA_DOCUMENTO === CATEGORIA_SELECCIONADO)
            }

            if (PAIS_SELECCIONADO !== "" && CATEGORIA_SELECCIONADO !== "") {
                resultado = REGISTROS.filter((registro) => registro.ANYO === ANYO_SELECCIONADO && registro.CATEGORIA_DOCUMENTO === CATEGORIA_SELECCIONADO && registro.PAIS === PAIS_SELECCIONADO)
            }


        }
        return resultado;
    }



    const modificarRegistro = (PAYLOAD) => {

        SetDocumentoProveedorEnAPI(2, PAYLOAD).then((licencia) => {
            GetProveedorDetalle(props.REGISTRO_SELECCIONADO.ID);
        })
    }




    const marcaSeleccionada = (PAYLOAD) => {


        //let PAYLOAD_MARCA = { ID: 0, ID_PROVEEDOR: props.REGISTRO_SELECCIONADO.ID, ID_MARCA: PAYLOAD.Codigo }

        SetMarcaProveedorEnAPI(0, 0, props.REGISTRO_SELECCIONADO.ID, PAYLOAD.Codigo).then(() => {
            GetProveedorDetalle(props.REGISTRO_SELECCIONADO.ID);
        })


        /*
        SetDocumentoProveedorEnAPI(2, PAYLOAD).then((licencia) => {
            GetProveedorDetalle(props.REGISTRO_SELECCIONADO.ID);
        })
*/
    }

    const eliminarMarca = (PAYLOAD) => {
        const { ID, ID_MARCA, ID_PROVEEDOR } = PAYLOAD
        SetMarcaProveedorEnAPI(2, ID, ID_PROVEEDOR, ID_MARCA).then(() => {
            GetProveedorDetalle(props.REGISTRO_SELECCIONADO.ID);
        })
    }

    const verificarExtension = (EXTENSION) => {
        let ES_DOCUMENTO = false
        let comprobar = EXTENSION.replace(".", "")
        comprobar = comprobar.toLowerCase()
        if (comprobar === "pdf" || comprobar === "png" || comprobar === "bmp" || comprobar === "gif" || comprobar === "tif" || comprobar === "jpeg") {
            ES_DOCUMENTO = true
        }

        return ES_DOCUMENTO
    }


    const obtenerImagenPorExtension = (EXTENSION) => {
        EXTENSION = EXTENSION === undefined ? "" : EXTENSION.toUpperCase();
        let resultado = "";

        switch (EXTENSION) {
            case "PNG": case "JPG": case "JPEG": case "GIF":
                resultado = "imagen.png";
                break;
            case "PDF":
                resultado = "pdf.png";
                break;
            case "XLSX": case "XLSM": case "XLSB": case "XLTX": case "CSV": case "XLS":
                resultado = "excel.png"
                break;
            case "DOCX":
                resultado = "word.png"
                break;
            case "MP4": case "MOV": case "WMV": case "MKV":
                resultado = "video.png"
                break;
            case "ZIP": case "RAR":
                resultado = "comprimido.png"
                break;
            default:
                resultado = "generico.png"
                break;

        }
        return resultado;
    }

    const descargarDocumento = () => {
        const { ID, ID_PROVEEDOR } = documentoSeleccionado;
        window.open(`${ObtenerEndPoint()}api/NextGroup/DescargarDocumentoProveedor/${ID}/${ID_PROVEEDOR}/${window.btoa(obtenerToken())}`, '_blank').focus();

    }

    React.useEffect(() => {

        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })


    if (!hayCliente && props.ABRIR_FICHA) {
        setHayCliente(true);
        GetProveedorDetalle(props.REGISTRO_SELECCIONADO.ID);

    } else {
        if (!props.ABRIR_FICHA && hayCliente) {
            setHayCliente(false);

            setproveedor(
                {
                    CONTACTOS: [],
                    DETALLE: [],
                    DOCUMENTOS: [],
                    MARCAS: []
                }
            )
        }
    }


    return (
        <>
            <Drawer
                width={"90%"}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>


                <div className='containerDetalleProveedor'>
                    <div className='pantalla_item1'>

                        <div className='containerInfoProveedor'>

                            <div className='headerTab'>
                                <div className={`itemTabRegistro ${activeTabMenu === 1 ? "activeItemTab" : ""}`} onClick={() => { setActiveTabMenu(1) }}>{traducirPagina("GENERAL").toUpperCase()}</div>
                                <div className={`itemTabRegistro ${activeTabMenu === 2 ? "activeItemTab" : ""}`} onClick={() => { setActiveTabMenu(2) }}>{traducirPagina("CONTACTOS").toUpperCase()}</div>
                            </div>

                            <div className='bodyTab'>
                                <div className={activeTabMenu === 1 && "activeBodyTab"}>
                                    {proveedor.CONTACTOS === null ?
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                        :
                                        <>
                                            <div className='form_datos'>
                                                <span className='separador_form'>{traducirPagina("Informacion_fiscal")} </span>

                                                <div className='datos_proveedor'>
                                                    <div className='agrupar_datos'>
                                                    </div>

                                                    <div>
                                                        <div className='txt_titulo'>
                                                            {traducirPagina("Datos_fiscales")}
                                                        </div>
                                                        <div className='txt_descripcion'>
                                                            {`${CIF} - ${NOMBRE_FISCAL}`}
                                                        </div>

                                                        <div className='txt_titulo'>
                                                            {traducirPagina("Direccion_fiscal")}
                                                        </div>
                                                        <div className='txt_descripcion'>
                                                            {`${DIRECCION_FISCAL},${PAIS_FISCAL} ${POBLACION_FISCAL} ${PROVINCIA_FISCAL} ${CODIGO_POSTAL_FISCAL} `}
                                                        </div>

                                                        <div className='txt_titulo'>
                                                            {traducirPagina("Telefono")}
                                                        </div>
                                                        <div className='txt_descripcion'>
                                                            {`${TELEFONO1}, ${TELEFONO2}, ${TELEFONO3}`}
                                                        </div>

                                                        {INFORMACION_ADICIONAL_FISCAL !== "" ?
                                                            <>
                                                                <div className='txt_titulo'>
                                                                    {traducirPagina("Msg_info_fiscal")}
                                                                </div>
                                                                <div className='txt_descripcion'>
                                                                    {`${INFORMACION_ADICIONAL_FISCAL}`}
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                        }

                                                    </div>

                                                </div>
                                            </div>

                                            <div className='form_datos'>
                                                <span className='separador_form'>{traducirPagina("Info_comercial")} </span>

                                                <div className='datos_proveedor'>
                                                    <div className='agrupar_datos'>
                                                    </div>

                                                    <div>
                                                        <div className='txt_titulo'>
                                                            {traducirPagina("Nombre_comercial")}
                                                        </div>
                                                        <div className='txt_descripcion'>
                                                            {`${NOMBRE_COMERCIAL}`}
                                                        </div>

                                                        <div className='txt_titulo'>
                                                            {traducirPagina("Direccion_local")}
                                                        </div>
                                                        <div className='txt_descripcion'>
                                                            {`${DIRECCION_LOCAL},${PAIS_LOCAL} ${POBLACION_LOCAL} ${PROVINCIA_LOCAL} ${CODIGO_POSTAL_LOCAL} `}
                                                        </div>

                                                        <div className='txt_titulo'>
                                                            {traducirPagina("Email")}
                                                        </div>
                                                        <div className='txt_descripcion'>
                                                            {`${EMAIL}`}
                                                        </div>

                                                        {INFORMACION_ADICIONAL_LOCAL !== "" ?
                                                            <>
                                                                <div className='txt_titulo'>
                                                                    {traducirPagina("Msg_adicional_local")}
                                                                </div>
                                                                <div className='txt_descripcion'>
                                                                    {`${INFORMACION_ADICIONAL_LOCAL}`}
                                                                </div>
                                                            </>
                                                            :
                                                            null
                                                        }

                                                    </div>
                                                </div>

                                            </div>

                                            <div className='form_datos'>
                                                <span className='separador_form'>{traducirPagina("Homologacion")} </span>

                                                <div className='datos_proveedor'>
                                                    <div className='agrupar_datos'>
                                                    </div>
                                                    <div>
                                                        {proveedor.CONTACTOS === null ?
                                                            null
                                                            :
                                                            <div className='container_Homologacion'>

                                                                <div>
                                                                    <Checkbox checked={HOMOLOGADO_SERCA}>
                                                                        
                                                                        {`${traducirPagina("Homologado")} Serca`}
                                                                    </Checkbox>
                                                                </div>

                                                                <div>
                                                                    <Checkbox checked={HOMOLOGADO_IDAP}>
                                                                
                                                                        {`${traducirPagina("Homologado")} IDAP`}
                                                                    </Checkbox>
                                                                </div>

                                                                <div>
                                                                    <Checkbox checked={HOMOLOGADO_NEXUS}>
                                                                        
                                                                        {`${traducirPagina("Homologado")} NEXUS`}
                                                                    </Checkbox>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        </>
                                    }


                                </div>
                                <div className={activeTabMenu === 2 && "activeBodyTab"}>
                                    {proveedor.CONTACTOS === null ?
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                        :
                                        proveedor.CONTACTOS !== null && proveedor.CONTACTOS.length > 0 ?

                                            <div className="container_list">
                                                <ul className="responsive-table">
                                                    <li className="table-header">
                                                        <div className="item_contacto_col1">{traducirPagina("Nombre").toUpperCase()}</div>
                                                        <div className="item_contacto_col2">{traducirPagina("Email").toUpperCase()}</div>
                                                        <div className="item_contacto_col3">{traducirPagina("Telefono").toUpperCase()}</div>
                                                    </li>

                                                    {proveedor.CONTACTOS.map((registro, i) =>
                                                        <li className="table-row" style={proveedor.CONTACTOS.length - 1 === i ? { borderBottom: 'none' } : {}}>
                                                            <div className="item_contacto_col1" data-label="NOMBRE">
                                                                <div>{`${registro.NOMBRE} ${registro.APELLIDOS}`}</div>
                                                                <div className='puesto_contacto'>{registro.PUESTO}</div>
                                                            </div>
                                                            <div className="item_contacto_col2" data-label="EMAIL">{registro.EMAIL}</div>
                                                            <div className="item_contacto_col3" data-label="TELÉFONO">{`${registro.TELEFONO1} : ${registro.TELEFONO2} `}</div>
                                                        </li>
                                                    )
                                                    }

                                                </ul>
                                            </div>


                                            :
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                    }



                                </div>
                            </div>
                        </div>


                        <div className='card_proveedor_marca'>
                            <div className='card_pr_header'>
                                <div className='card_pr_header_titulo'>
                                    {traducirPagina("Marcas").toUpperCase()}
                                </div>
                            </div>

                            <div className='card_marca_proveedor'>

                                <div className='containerMarcasProveedor'>
                                    {proveedor.MARCAS === null ?
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                        :
                                        proveedor.MARCAS !== null && proveedor.MARCAS.length > 0 ?

                                            proveedor.MARCAS.map((registro, i) =>

                                                <div className="estiloCategorias_marcas" key={i}>
                                                    <div className='texto_marca'>
                                                        {registro.NOMBRE_MARCA}
                                                    </div>

                                                    <div className='grupo_iconos_marca'>
                                                        <div onClick={() => { setAbrirTarifas(true); setRegistroMarcaSeleccionada(registro) }}>  {traducirPagina("Tarifa")}   <DollarCircleFilled  ></DollarCircleFilled></div>
                                                    </div>
                                                </div>

                                            )
                                            :
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                    }
                                </div>


                            </div>
                        </div>


                    </div>

                    <div className='pantalla_item2'>

                        <div className='card_pr_header'>
                            <div className='card_pr_header_titulo'>
                                {traducirPagina("Documentos").toUpperCase()}
                            </div>

                            <div className='grupo_filtros' ref={ref}>
                                <div>
                                    {proveedor.DOCUMENTOS !== null ?
                                        <Select
                                            showSearch
                                            allowClear={filtroUnicoPais(proveedor.DOCUMENTOS).length > 1 ? true : false}

                                            placeholder={traducirPagina("Filtrar_pais")}
                                            style={{ width: "160px", textAlign: 'left' }}
                                            onChange={(e) => {
                                                filtros.ANYO_ACTIVO = false;

                                                if (e === undefined || e === null) {
                                                    filtros.PAIS_SELECCIONADO = ""
                                                } else {
                                                    filtros.PAIS_SELECCIONADO = e
                                                }
                                                setFiltros({ ...filtros })
                                            }}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {filtroUnicoPais(proveedor.DOCUMENTOS).length > 0 ?
                                                filtroUnicoPais(proveedor.DOCUMENTOS).map((registro) =>
                                                    <Option key={registro} value={registro}>{registro}</Option>
                                                )
                                                :
                                                null
                                            }
                                        </Select>
                                        :
                                        null
                                    }
                                </div>

                                <div>
                                    {proveedor.DOCUMENTOS !== null ?
                                        <Select
                                            showSearch
                                            allowClear={true}

                                            placeholder={traducirPagina("Filtrar_categoria")}
                                            style={{ width: "160px", textAlign: 'left' }}
                                            onChange={(e) => {
                                                filtros.ANYO_ACTIVO = false;

                                                if (e === undefined || e === null) {
                                                    filtros.CATEGORIA_SELECCIONADO = ""
                                                } else {
                                                    filtros.CATEGORIA_SELECCIONADO = e
                                                }
                                                setFiltros({ ...filtros })
                                            }}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {filtroUnicoCategoria(proveedor.DOCUMENTOS).length > 0 ?
                                                filtroUnicoCategoria(proveedor.DOCUMENTOS).map((registro) =>
                                                    <Option key={registro} value={registro}>{registro}</Option>
                                                )
                                                :
                                                null
                                            }
                                        </Select>
                                        :
                                        null
                                    }
                                </div>


                                <div className='btn_filtro_anyo'>

                                    {proveedor.DOCUMENTOS !== null ?
                                        <Select
                                            showSearch
                                            allowClear={true}
                                            Value={filtros.ANYO_SELECCIONADO}

                                            placeholder={traducirPagina("Anio")}

                                            style={{ width: "160px", textAlign: 'left' }}
                                            onChange={(e) => {
                                                filtros.ANYO_ACTIVO = true;

                                                if (e === undefined || e === null) {
                                                    filtros.ANYO_SELECCIONADO = ""
                                                } else {
                                                    filtros.ANYO_SELECCIONADO = e
                                                }
                                                setFiltros({ ...filtros })
                                            }}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {filtroUnicoAnyo(proveedor.DOCUMENTOS).length > 0 ?
                                                filtroUnicoAnyo(proveedor.DOCUMENTOS).map((registro) =>
                                                    <Option key={registro} value={registro}>{registro}</Option>
                                                )
                                                :
                                                null
                                            }
                                        </Select>
                                        :
                                        null
                                    }
                                </div>


                            </div>
                        </div>

                        <div className='card_documento_proveedor' style={{ height: `calc(100% - ${(50 + alturaSubmenu)}px)` }}>

                            {proveedor.DOCUMENTOS === null ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                :
                                proveedor.DOCUMENTOS !== null && proveedor.DOCUMENTOS.length > 0 ?

                                    <div className="container_list">
                                        <ul className="responsive-table">
                                            <li className="table-header">
                                                <div className="item_col1">{traducirPagina("Nombre").toUpperCase()}</div>
                                                <div className="item_col2">{traducirPagina("Anio")}</div>
                                                <div className="item_col3">{traducirPagina("Pais")}</div>
                                                <div className="item_col4">{traducirPagina("Categoria")}</div>
                                            </li>

                                            {gestionnarFiltrosLocales(proveedor.DOCUMENTOS).map((registro, i) =>
                                                <li className="table-row" style={gestionnarFiltrosLocales(proveedor.DOCUMENTOS).length - 1 === i ? { borderBottom: 'none' } : {}} onClick={() => {

                                                    setDocumentoSeleccionado(registro)

                                                    if (verificarExtension(registro.EXTENSION)) {
                                                        obtenerDocumento(registro.ID, registro.ID_PROVEEDOR, registro.NOMBRE, registro.EXTENSION)

                                                    } else {
                                                        window.open(`${ObtenerEndPoint()}api/NextGroup/DescargarDocumentoProveedor/${registro.ID}/${registro.ID_PROVEEDOR}/${window.btoa(obtenerToken())}`, '_blank').focus();

                                                    }
                                                }}>
                                                    <div className="item_col1" data-label="NOMBRE">{`${registro.NOMBRE}.${registro.EXTENSION}`}</div>
                                                    <div className="item_col2" data-label="AÑO">{registro.ANYO}</div>
                                                    <div className="item_col3" data-label="PAÍS">{registro.PAIS}</div>
                                                    <div className="item_col4" data-label="CATEGORíA">{registro.CATEGORIA_DOCUMENTO}</div>
                                                </li>
                                            )
                                            }

                                        </ul>
                                    </div>


                                    :
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }
                        </div>
                    </div>
                </div>
            </Drawer>


         


            {
                abrirVisor ?
                    <VisorGenerico
                        title={""}
                        ABRIR_VISOR={abrirVisor}
                        CERRAR_VISOR={setAbrirVisor}
                        PROPIEDADES_DOC={ficheroSeleccionado}
                        MOSTRAR_BOTON_DESCARGA={true}
                        EVENTO_DESCARGA={descargarDocumento}
                    >
                    </VisorGenerico>
                    :
                    null
            }

            {
                abrirTarifas ?
                    <FichaTarifasProveedor
                        title={`${traducirPagina("TARIFA_DE_PRECIOS").toUpperCase()} ${registroMarcaSeleccionada.NOMBRE_MARCA} ${traducirPagina("A_DIA").toUpperCase()}`}
                        ABRIR_FICHA={abrirTarifas}
                        CERRAR_FICHA={setAbrirTarifas}
                        
                        ID_MARCA={registroMarcaSeleccionada.ID_MARCA}
                        ID_PROVEEDOR={props.REGISTRO_SELECCIONADO.ID}

                        NOMBRE_MARCA={registroMarcaSeleccionada.NOMBRE_MARCA}
                        MANTENIMIENTO_PROVEEDOR={props.REGISTRO_SELECCIONADO}
                    >
                    </FichaTarifasProveedor>
                    :
                    null
            }




        </>

    )
}

FichaDetalleProveedor.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,

    REGISTRO_SELECCIONADO: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaDetalleProveedor);